var cache = {};

module.exports = _.extend({
  initialize: function () {},
  clear: function () {
    cache = {};
    this.trigger('cleared');
  },

  set: function (params) {
    params['design_id'] = params['design_id'] || INKIVE.Tool._current_design_id;
    cache[params['design_id']] = params['data'];
  },

  get: function (params) {
    params = params || { 'design_id': INKIVE.Tool._current_design_id };
    return cache[params['design_id']];
  },

  getAll: function () {
    return cache;
  },

  remove: function (params) {
    var newCache = {};
    params = params || { 'design_id': INKIVE.Tool._current_design_id };

    _.each(cache, function (data, index) {
      if (index != params['design_id']) {
        var newIndex = index > params['design_id'] ? parseInt(index) - 1 : index;
        newCache[newIndex] = data;
      }
    });

    cache = newCache;
    this.trigger('removed');
  },

  add: function (params) {
    var newCache = {};
    params = params || { 'design_id': INKIVE.Tool._current_design_id };

    _.each(cache, function (data, index) {
      var newIndex = index >= params['design_id'] ? parseInt(index) + 1 : index;
      newCache[newIndex] = data;
    });

    cache = newCache;
  }
}, Backbone.Events);
